import application_container from '@frontend/application-container';

export function round_decimals(x: number): number {
    const pow = 10**application_container.settings.coordinate_decimals;
    return Math.round((x + Number.EPSILON) * pow)/pow;
}
